/**
 * AdvertisingPlatform
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { Campaignservicev1OrderLine } from '../models/Campaignservicev1OrderLine';
import { HttpFile } from '../http/http';

/**
* Contains a list of order lines and the token for the next page of order lines
*/
export class V1ListOrderLinesResponse {
    'orderLines'?: Array<Campaignservicev1OrderLine>;
    /**
    * A token, which can be sent as `page_token` to retrieve the next page. If this field is omitted, there are no subsequent pages.
    */
    'nextPageToken'?: string;
    /**
    * The total count of order lines irrespective of pagination. If filtering is used, the `total_size` field reflects the total count of order lines after the filter is applied.
    */
    'totalSize'?: number;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "orderLines",
            "baseName": "order_lines",
            "type": "Array<Campaignservicev1OrderLine>",
            "format": ""
        },
        {
            "name": "nextPageToken",
            "baseName": "next_page_token",
            "type": "string",
            "format": ""
        },
        {
            "name": "totalSize",
            "baseName": "total_size",
            "type": "number",
            "format": "int32"
        }    ];

    static getAttributeTypeMap() {
        return V1ListOrderLinesResponse.attributeTypeMap;
    }

    public constructor() {
    }
}

